export const MAX_FILE_SIZE_IN_MB = 5;
export const MAX_FILE_AMOUNT_COUNT = 10;
